module.exports = __webpack_public_path__ + "static/6-f9fe1b02108ca98b97e16b93703b974c.jpg";